import { useEffect, useState, useCallback, useMemo } from "react";
import { useNavigate } from "react-router-dom";

function useApi({
  callback = () => {},
  dependencies = [],
  payload = "",
  shouldCallApi = true,
  onSuccess = () => {},
  onError = () => {},
  onPreFetch = () => {},
}) {
  const [data, setData] = useState({
    error: false,
    data: [],
    pagination: {},
    loading: null,
    catch: null,
  });
  const Navigate = useNavigate();
  const memoizedCallback = useCallback(callback, [callback]);
  const memoizedDependencies = useMemo(() => dependencies, [dependencies]);

  useEffect(() => {
    if (!memoizedCallback || !shouldCallApi) return;
    onPreFetch && onPreFetch();
    const fetchData = async () => {
      setData((pre) => ({ ...pre, loading: true }));
      try {
        const reqPayload = Array.isArray(payload) ? payload : [payload];
        const res = await memoizedCallback(...reqPayload);
        setData({
          error: false,
          data: res.data,
          loading: false,
          catch: null,
          pagination: res?.pagination || {},
        });
        if (res && onSuccess) {
          const {
            page = 0,
            limit = 0,
            totalDocs = 0,
            totalPages = 0,
          } = res?.pagination || {};
          onSuccess(res, { page, limit, totalDocs, totalPages });
        }
      } catch (error) {
        console.log("useApi error", error);

        if (error?.response?.data?.code === 401) {
          localStorage.clear();
          Navigate("/login");
        }
        if (onError) onError(error?.response?.data?.message || "");
        setData({
          error: true,
          data: [],
          loading: false,
          catch: error,
          pagination: {},
        });
      }
    };
    fetchData();
  }, [memoizedCallback, shouldCallApi, ...memoizedDependencies]);

  return [data, setData];
}

export default useApi;
